import React from 'react';
import css from './radio-group.module.scss';
import RadioGroupBase from '@mui/material/RadioGroup';

const RadioGroup = (props: React.ComponentProps<typeof RadioGroupBase>) => (
  <RadioGroupBase className={css.root} {...props} />
);

export default RadioGroup;
